import { render, staticRenderFns } from "./LastUpdateInfo.vue?vue&type=template&id=06364dc8&"
import script from "./LastUpdateInfo.vue?vue&type=script&lang=js&"
export * from "./LastUpdateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports